import StatusCodes from 'http-status-codes'

import { RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type ICardRepository } from '../../interfaces/ICardRepository'
import { SpendingCardUseCaseErrors } from '../SpendingCardUseCaseErrors'

export class GetVirtualCardPaymentDetailsUseCase {
  constructor(
    private deps: {
      cardRepository: ICardRepository
    }
  ) {}

  execute = async ({
    externalId,
    scaToken,
    customCss = {},
  }: {
    externalId: string
    scaToken?: string
    customCss?: Record<string, Record<string, string>>
  }) => {
    try {
      return await this.deps.cardRepository.getPaymentDetailsIframeUrl(
        externalId,
        customCss,
        scaToken
      )
    } catch (err) {
      if (
        err instanceof RepoError &&
        err.status === StatusCodes.FORBIDDEN &&
        err.headers['x-sca-session-code']
      ) {
        return {
          data: {
            url: undefined,
            scaSessionCode: err.headers['x-sca-session-code'],
          },
        }
      } else {
        throw new SpendingCardUseCaseErrors({
          name: 'ERROR_GETTING_VIRTUAL_CARD_PAYMENT_DETAILS',
          message: 'Failed to get virtual card payment details',
        })
      }
    }
  }
}
